import ApiService from '@/common/api.service'
import { displayNotification } from '@/common/notification'

export const state = {
  livingOptions: [],
  subsections: [],
  properties: [],
  propertyModels: [],
  structuredProperties: [],
  allStructuredProperties: [],
}

export const getters = {
  livingOptions (state) { return state.livingOptions },
  subsections (state) { return state.subsections },
  availableProperties (state) {
    return state.properties.filter(property => {
      return property.status === 'Available' || property.status === 'Blocked'
    })
  },
  allStructuredProperties (state) { return state.allStructuredProperties },
  structuredProperties (state) { return state.structuredProperties },
  properties (state) { return state.properties },
  propertyModels (state) { return state.propertyModels },
}

export const mutations = {
  ADD_PROPERTY_MODEL (state, propertyModel) {
    state.propertyModels.unshift(propertyModel)
  },

  SET_PROPERTY_MODELS (state, propertyModels) {
    state.propertyModels = propertyModels
  },

  ADD_PROPERTY (state, property) {
    state.properties.unshift(property)
  },

  SET_PROPERTIES (state, properties) {
    state.properties = properties
  },

  SET_STRUCTURED_PROPERTIES (state, properties) {
    state.structuredProperties = properties
  },

  SET_STRUCTURED_PROPERTIES_ALL (state, properties) {
    state.allStructuredProperties = properties
  },

  ADD_SUBSECTION (state, subsection) {
    state.subsections.unshift(subsection)
  },

  SET_SUBSECTIONS (state, subsections) {
    state.subsections = subsections
  },
  ADD_LIVING_OPTION (state, livingOption) {
    state.livingOptions.unshift(livingOption)
  },

  SET_LIVING_OPTIONS (state, livingOptions) {
    state.livingOptions = livingOptions
  },
}

export const actions = {
  async FETCH_LIVING_OPTIONS ({ commit }) {
    try {
      const { data } = await ApiService.get('living/living-options')
      commit('SET_LIVING_OPTIONS', data)
    } catch (e) {
      displayNotification('Error Fetching Living Options: ' + e, 'warning')
    }
  },

  async FETCH_SUBSECTIONS ({ commit }) {
    try {
      const { data } = await ApiService.get('living/subsections')
      commit('SET_SUBSECTIONS', data)
    } catch (e) {
      displayNotification('Error Fetching Subsections: ' + e, 'warning')
    }
  },

  async FETCH_PROPERTIES ({ commit }) {
    try {
      const { data } = await ApiService.get('living/properties')
      commit('SET_PROPERTIES', data)
    } catch (e) {
      displayNotification('Error Fetching Properties: ' + e, 'warning')
    }
  },

  async FETCH_STRUCTURED_PROPERTIES ({ commit }) {
    try {
      const { data } = await ApiService.get('living/properties/structured')
      commit('SET_STRUCTURED_PROPERTIES', data)
    } catch (e) {
      displayNotification('Error Fetching Properties: ' + e, 'warning')
    }
  },

  async FETCH_STRUCTURED_PROPERTIES_ALL ({ commit }) {
    try {
      const { data } = await ApiService.get('living/properties/structured/all')
      commit('SET_STRUCTURED_PROPERTIES_ALL', data)
    } catch (e) {
      displayNotification('Error Fetching Properties: ' + e, 'warning')
    }
  },

  async FETCH_PROPERTY_MODELS ({ commit }) {
    try {
      const { data } = await ApiService.get('living/property-models')
      commit('SET_PROPERTY_MODELS', data)
    } catch (e) {
      displayNotification('Error Fetching Property Models: ' + e, 'warning')
    }
  },

  async SAVE_LIVING_OPTION ({ commit, dispatch }, livingOption) {
    try {
      if (livingOption._id === 'temp') {
        delete livingOption._id
        await ApiService.post('living/living-options', { livingOption: livingOption })
      } else {
        await ApiService.put(`living/living-options/${livingOption._id}`, { livingOption: livingOption })
      }
      displayNotification("Successfully Updated Living Option", "success");
    } catch (e) {
      displayNotification('Error Saving Living Option: ' + e, 'warning')
    } finally {
      dispatch('FETCH_LIVING_OPTIONS')
    }
  },

  async DELETE_LIVING_OPTION ({ commit, dispatch }, subsectionId) {
    try {
      await ApiService.delete('living/living-options', subsectionId).then(res => {
        if (res.data.errors) {
          res.data.errors.forEach(error => {
            displayNotification(error, "warning");
          });

        } else {
          displayNotification("Deleted Living Option", "success");
        }
      })

    } catch (e) {
      displayNotification('Error Deleting Living Option: ' + e, 'warning')
    } finally {
      dispatch('FETCH_LIVING_OPTIONS')
    }
  },

  async SAVE_SUBSECTION ({ commit, dispatch }, subsection) {
    try {
      if (subsection._id === 'temp') {
        delete subsection._id
        await ApiService.post('living/subsections', { subsection: subsection })
      } else {
        await ApiService.put(`living/subsections/${subsection._id}`, { subsection: subsection })
      }
      displayNotification("Successfully Updated Subsection", "success");
    } catch (e) {
      displayNotification('Error Saving Subsection: ' + e, 'warning')
    } finally {
      dispatch('FETCH_SUBSECTIONS')
    }
  },

  async SAVE_PROPERTY ({ commit, dispatch }, property) {
    try {
      if (property._id === 'temp') {
        delete property._id
        await ApiService.post('living/properties', { property: property })
      } else {
        await ApiService.put(`living/properties/${property._id}`, { property: property })
      }
      displayNotification("Successfully Property", "success");
    } catch (e) {
      displayNotification('Error Saving Property: ' + e, 'warning')
    } finally {
      dispatch('FETCH_PROPERTIES')
    }
  },

  async DELETE_PROPERTY ({ commit, dispatch }, property) {
    try {
      await ApiService.delete(`living/properties`, property._id)
      displayNotification("Successfully Deleted Property", "success");
    } catch (e) {
      displayNotification('Error Deleting Property: ' + e, 'warning')
    } finally {
      dispatch('FETCH_PROPERTIES')
    }
  },

  async SAVE_PROPERTY_MODEL ({ commit, dispatch }, propertyModel) {
    try {
      if (propertyModel._id === 'temp') {
        delete propertyModel._id
        await ApiService.post('living/property-models', { propertyModel: propertyModel })
      } else {
        await ApiService.put(`living/property-models/${propertyModel._id}`, { propertyModel: propertyModel })
      }
      displayNotification("Successfully Property Model", "success");
    } catch (e) {
      displayNotification('Error Saving Property Model: ' + e, 'warning')
    } finally {
      dispatch('FETCH_PROPERTY_MODELS')
    }
  },
}

export default {
  state,
  actions,
  mutations,
  getters
}
